import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
import qs from "qs";
/**
 * 测量点
 */
const measure = {
  /**
   * 添加模板组
   */
  addMeasureTemplateGroup(parentId, name, displayName, orderNum) {
    return axios.post(
      base.measure.addMeasureTemplateGroup,
      utils.postParamsArrayToJsonString({
        parentId,
        name,
        displayName,
        orderNum,
      })
    );
  },
  /**
  * 从容器内查询测量点
  * @param {*} measureId 测量点id
  * @param {*} container ''。
  * @param {*} typeClass:TypeOfElectricityConsumption
   当此参数为空/null时，返回该测量点所有容器内容
  */
  getBottomNodeEnumClass(measureId, typeClass, container) {
    let params = {
      measureId,
      typeClass,
      container,
    };
    return axios.post(
      base.measure.getBottomNodeEnumClass,
      qs.stringify(params)
    );
  },
  listPhotosOfMeasureByPack(measureIds) {
    const data = new FormData();
    data.append("measureIds", measureIds);
    return axios.post(base.measure.listPhotosOfMeasureByPack, data);
  },
  /**
   * 修改模板组
   */
  modifyMeasureTemplateGroup(id, parentId, name, displayName, orderNum) {
    return axios.post(
      base.measure.modifyMeasureTemplateGroup,
      utils.postParamsArrayToJsonString({
        id,
        parentId,
        name,
        displayName,
        orderNum,
      })
    );
  },
  /**
   * 删除模板组
   */
  deleteMeasureTemplateGroup(id) {
    return axios.post(
      base.measure.deleteMeasureTemplateGroup,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询模板组
   */
  getMeasureTemplateGroups() {
    return axios.post(
      base.measure.getMeasureTemplateGroups,
      utils.postParamsArrayToJsonString({})
    );
  },
  /**
   * 新增模板
   */
  addMeasureTemplate(name, displayName, deviceModelId, groupId) {
    return axios.post(
      base.measure.addMeasureTemplate,
      utils.postParamsArrayToJsonString({
        name,
        displayName,
        deviceModelId,
        groupId,
      })
    );
  },
  /**
   * 修改模板
   */
  modifyMeasureTemplate(id, name, displayName) {
    return axios.post(
      base.measure.modifyMeasureTemplate,
      utils.postParamsArrayToJsonString({ id, name, displayName })
    );
  },
  /**
   * 查询模板
   */
  getMeasureTemplates() {
    return axios.post(
      base.measure.getMeasureTemplates,
      utils.postParamsArrayToJsonString({})
    );
  },
  /**
   * 查询模板
   */
  getMeasureTemplates2(groupId) {
    return axios.post(
      base.measure.getMeasureTemplates2,
      utils.postParamsArrayToJsonString({ groupId })
    );
  },
  /**
   * 删除参数模板
   */
  deleteMeasureTemplate(id) {
    return axios.post(
      base.measure.deleteMeasureTemplate,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 添加参数模板组
   */
  addMeasurePropertyTemplateGroup(templateId, name, displayName, orderNum) {
    return axios.post(
      base.measure.addMeasurePropertyTemplateGroup,
      utils.postParamsArrayToJsonString({
        templateId,
        name,
        displayName,
        orderNum,
      })
    );
  },
  /**
   * 修改参数模板组
   */
  modifyMeasurePropertyTemplateGroup(id, name, displayName, orderNum) {
    return axios.post(
      base.measure.modifyMeasurePropertyTemplateGroup,
      utils.postParamsArrayToJsonString({ id, name, displayName, orderNum })
    );
  },
  /**
   * 删除参数模板组
   */
  deleteMeasurePropertyTemplateGroup(id) {
    return axios.post(
      base.measure.deleteMeasurePropertyTemplateGroup,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询参数模板组
   */
  getMeasurePropertyTemplateGroups(templateId) {
    return axios.post(
      base.measure.getMeasurePropertyTemplateGroups,
      utils.postParamsArrayToJsonString({ templateId })
    );
  },
  /**
   * 新增属性模板参数项
   */
  addMeasurePropertyTemplateItem(
    groupId,
    name,
    displayName,
    valueType,
    defaultValue,
    enumClass,
    canValueEmpty,
    changeable
  ) {
    return axios.post(
      base.measure.addMeasurePropertyTemplateItem,
      utils.postParamsArrayToJsonString({
        groupId,
        name,
        displayName,
        valueType,
        defaultValue,
        enumClass,
        canValueEmpty,
        changeable,
      })
    );
  },
  /**
   * 修改属性模板项
   */
  modifyMeasurePropertyTemplateItem(
    id,
    name,
    displayName,
    valueType,
    defaultValue,
    enumClass,
    canValueEmpty,
    changeable
  ) {
    return axios.post(
      base.measure.modifyMeasurePropertyTemplateItem,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        valueType,
        defaultValue,
        enumClass,
        canValueEmpty,
        changeable,
      })
    );
  },
  /**
   * 查询属性模板项
   */
  getMeasurePropertyTemplateItems(groupId) {
    return axios.post(
      base.measure.getMeasurePropertyTemplateItems,
      utils.postParamsArrayToJsonString({ groupId })
    );
  },
  /**
   * 查询属性模板项
   */
  getMeasurePropertyTemplateItems2(groupsId) {
    return axios.post(
      base.measure.getMeasurePropertyTemplateItems2,
      utils.postParamsArrayToJsonString({ groupsId })
    );
  },
  /**
   * 删除属性模板项
   */
  deleteMeasurePropertyTemplateItem(id, cleanup) {
    return axios.post(
      base.measure.deleteMeasurePropertyTemplateItem,
      utils.postParamsArrayToJsonString({ id, cleanup })
    );
  },
  /**
   * 添加计算公式模板组
   */
  addMeasureExpressionTemplateGroup(templateId, name, displayName, orderNum) {
    return axios.post(
      base.measure.addMeasureExpressionTemplateGroup,
      utils.postParamsArrayToJsonString({
        templateId,
        name,
        displayName,
        orderNum,
      })
    );
  },
  /**
   * 修改计算公式模板组
   */
  modifyMeasureExpressionTemplateGroup(id, name, displayName, orderNum) {
    return axios.post(
      base.measure.modifyMeasureExpressionTemplateGroup,
      utils.postParamsArrayToJsonString({ id, name, displayName, orderNum })
    );
  },
  /**
   * 删除计算公式模板组
   */
  deleteMeasureExpressionTemplateGroup(id) {
    return axios.post(
      base.measure.deleteMeasureExpressionTemplateGroup,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询计算公式模板组
   */
  getMeasureExpressionTemplateGroups(templateId) {
    return axios.post(
      base.measure.getMeasureExpressionTemplateGroups,
      utils.postParamsArrayToJsonString({ templateId })
    );
  },
  /**
   * 增加测量点模板计量点公式
   */
  addMeasureExpressionTemplateItem(
    groupId,
    name,
    displayName,
    pointCode,
    pointNumber,
    expressionForChangingValue,
    expressionForChoosingPoints,
    defaultUnit
  ) {
    return axios.post(
      base.measure.addMeasureExpressionTemplateItem,
      utils.postParamsArrayToJsonString({
        groupId,
        name,
        displayName,
        pointCode,
        pointNumber,
        expressionForChangingValue,
        expressionForChoosingPoints,
        defaultUnit,
      })
    );
  },
  /**
   * 修改测量点模板计量点公式
   */
  modifyMeasureExpressionTemplateItem(
    id,
    displayName,
    pointCode,
    pointNumber,
    expressionForChangingValue,
    expressionForChoosingPoints,
    groupId,
    defaultUnit
  ) {
    return axios.post(
      base.measure.modifyMeasureExpressionTemplateItem,
      utils.postParamsArrayToJsonString({
        id,
        displayName,
        pointCode,
        pointNumber,
        expressionForChangingValue,
        expressionForChoosingPoints,
        groupId,
        defaultUnit,
      })
    );
  },
  /**
   * 删除测量点模板计量点公式
   */
  deleteMeasureExpressionTemplateItem(id) {
    return axios.post(
      base.measure.deleteMeasureExpressionTemplateItem,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询测量点模板计量点公式
   */
  getMeasureExpressionTemplateItems(groupId) {
    return axios.post(
      base.measure.getMeasureExpressionTemplateItems,
      utils.postParamsArrayToJsonString({ groupId })
    );
  },
  /**
   * 查询测量点模板计量点公式
   */
  getMeasureExpressionTemplateItems2(groupsId) {
    return axios.post(
      base.measure.getMeasureExpressionTemplateItems2,
      utils.postParamsArrayToJsonString({ groupsId })
    );
  },
  /**
   * 增加测量点模板容器
   */
  addContainerOfMeasureTemplate(
    templateId,
    name,
    displayName,
    itemClassRestrictions
  ) {
    return axios.post(
      base.measure.addContainerOfMeasureTemplate,
      utils.postParamsArrayToJsonString({
        templateId,
        name,
        displayName,
        itemClassRestrictions,
      })
    );
  },
  /**
   * 修改测量点模板容器
   */
  modifyContainerOfMeasureTemplate(
    id,
    name,
    displayName,
    itemClassRestrictions
  ) {
    return axios.post(
      base.measure.modifyContainerOfMeasureTemplate,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        itemClassRestrictions,
      })
    );
  },
  /**
   * 删除测量点模板容器
   */
  deleteContainerOfMeasureTemplate(id) {
    return axios.post(
      base.measure.deleteContainerOfMeasureTemplate,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询测量点模板容器
   */
  getContainerOfMeasureTemplate(templateId) {
    return axios.post(
      base.measure.getContainerOfMeasureTemplate,
      utils.postParamsArrayToJsonString({ templateId })
    );
  },
  /**
   * 设置模板告警编码约束
   */
  setEventCodeRestrictionOfMeasureTemplate(templateId, restriction) {
    return axios.post(
      base.measure.setEventCodeRestrictionOfMeasureTemplate,
      utils.postParamsArrayToJsonString({ templateId, restriction })
    );
  },
  /**
   * 获取模板告警编码约束
   */
  getEventCodeRestrictionOfMeasureTemplate(templateId) {
    return axios.post(
      base.measure.getEventCodeRestrictionOfMeasureTemplate,
      utils.postParamsArrayToJsonString({ templateId })
    );
  },
  /**
   * 生成测量点id
   */
  generateMeasureId(companyId) {
    return axios.post(
      base.measure.generateMeasureId,
      utils.postParamsArrayToJsonString({ companyId })
    );
  },
  /**
   * 创建
   */
  createMeasure(id, name, remark, templateId, salespersonId, mountedOn) {
    return axios.post(
      base.measure.createMeasure,
      utils.postParamsArrayToJsonString({
        id,
        name,
        remark,
        templateId,
        salespersonId,
        mountedOn,
      })
    );
  },
  /**
   * 修改
   */
  modifyMeasure(id, name, remark, templateId, salespersonId, mountedOn) {
    return axios.post(
      base.measure.modifyMeasure,
      utils.postParamsArrayToJsonString({
        id,
        name,
        remark,
        templateId,
        salespersonId,
        mountedOn,
      })
    );
  },
  /**
   * 查询
   */
  getMeasuresInfo(ids) {
    return axios.post(
      base.measure.getMeasuresInfo,
      utils.postParamsArrayToJsonString({ ids })
    );
  },
  /**
   * 删除
   */
  deleteMeasure(id) {
    return axios.post(
      base.measure.deleteMeasure,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询
   */
  getMeasuresProperties(ids) {
    return axios.post(
      base.measure.getMeasuresProperties,
      utils.postParamsArrayToJsonString({ ids })
    );
  },
  /**
   * 查询
   */
  getMeasuresProperties2(ids) {
    return axios.post(
      base.measure.getMeasuresProperties2,
      utils.postParamsArrayToJsonString({ ids })
    );
  },
  /**
   * 查询
   */
  getMeasureProperty(id, name) {
    return axios.post(
      base.measure.getMeasureProperty,
      utils.postParamsArrayToJsonString({ id, name })
    );
  },
  /**
   * 设置测量点属性
   */
  setMeasureProperties(measureId, properties) {
    return axios.post(
      base.measure.setMeasureProperties,
      utils.postParamsArrayToJsonString({ measureId, properties })
    );
  },
  /**
   * 修改测量点属性
   */
  modifyMeasureProperty(measureId, name, value) {
    return axios.post(
      base.measure.modifyMeasureProperty,
      utils.postParamsArrayToJsonString({ measureId, name, value })
    );
  },
  /**
   * 获取告警编码约束
   */
  getMeasureEventCodeRestriction(measureId) {
    return axios.post(
      base.measure.getMeasureEventCodeRestriction,
      utils.postParamsArrayToJsonString({ measureId })
    );
  },
  /**
   * 添加测量点至容器
   */
  addItemsToMeasureContainer(measureId, containerName, items) {
    return axios.post(
      base.measure.addItemsToMeasureContainer,
      utils.postParamsArrayToJsonString({ measureId, containerName, items })
    );
  },
  /**
   * 从容器内查询测量点
   */
  getDirectSubNode(measureId, viewName) {
    return axios.post(
      base.measure.getDirectSubNode,
      utils.postParamsArrayToJsonString({ measureId, viewName })
    );
  },
  /**
   * 从容器内删除测量点
   */
  deleteItemsFromMeasureContainer(measureId, containerName, items) {
    return axios.post(
      base.measure.deleteItemsFromMeasureContainer,
      utils.postParamsArrayToJsonString({ measureId, containerName, items })
    );
  },
  /**
   * 查询
   */
  getMeasuresCurrentState(ids) {
    return axios.post(
      base.measure.getMeasuresCurrentState,
      utils.postParamsArrayToJsonString({ ids })
    );
  },
  /**
   * 变更状态
   */
  changeMeasureState(measureId, state) {
    return axios.post(
      base.measure.changeMeasureState,
      utils.postParamsArrayToJsonString({ measureId, state })
    );
  },
  /**
   * 查询状态历史记录
   */
  listMeasureStateChangingHistory(measureId) {
    return axios.post(
      base.measure.listMeasureStateChangingHistory,
      utils.postParamsArrayToJsonString({ measureId })
    );
  },
  /**
   * 查询
   */
  getMeasuresExpressions(ids) {
    return axios.post(
      base.measure.getMeasuresExpressions,
      utils.postParamsArrayToJsonString({ ids })
    );
  },
  /**
   * 查询计算公式
   * @param {*} measureId 测量点id
   */
  getMeasureExpressions(measureId) {
    const data = new FormData();
    data.append("measureId", measureId);
    return axios.post(base.measure.getMeasureExpressions, data, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  },
  /**
   * 修改计算公式
   */
  modifyMeasuringExpression(
    id,
    expressionForChangingValue,
    expressionForChoosingPoints,
    measuringByReference,
    referenceMeasureId,
    referencePointCode,
    referencePointNumber,
    calculateBySystem,
    startTime,
    endTime,
    defaultUnit
  ) {
    return axios.post(
      base.measure.modifyMeasuringExpression,
      utils.postParamsArrayToJsonString({
        id,
        expressionForChangingValue,
        expressionForChoosingPoints,
        measuringByReference,
        referenceMeasureId,
        referencePointCode,
        referencePointNumber,
        calculateBySystem,
        startTime,
        endTime,
        defaultUnit,
      })
    );
  },
  /**
   * 添加计算公式
   */
  addMeasuringExpression(
    measureId,
    pointCode,
    pointNumber,
    expressionForChangingValue,
    expressionForChoosingPoints,
    measuringByReference,
    referenceMeasureId,
    referencePointCode,
    referencePointNumber,
    calculateBySystem,
    startTime,
    endTime,
    defaultUnit
  ) {
    return axios.post(
      base.measure.addMeasuringExpression,
      utils.postParamsArrayToJsonString({
        measureId,
        pointCode,
        pointNumber,
        expressionForChangingValue,
        expressionForChoosingPoints,
        measuringByReference,
        referenceMeasureId,
        referencePointCode,
        referencePointNumber,
        calculateBySystem,
        startTime,
        endTime,
        defaultUnit,
      })
    );
  },
  /**
   * 删除计算公式
   */
  deleteMeasuringExpression(id) {
    return axios.post(
      base.measure.deleteMeasuringExpression,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 获取测量点相册照片信息
   */
  listPhotosOfMeasure(measureId) {
    return axios.post(
      base.measure.listPhotosOfMeasure,
      utils.postParamsArrayToJsonString({ measureId })
    );
  },
  /**
   * 加入测量点照片
   */
  addPhotoForMeasure(measureId, fileId, isCover) {
    return axios.post(
      base.measure.addPhotoForMeasure,
      utils.postParamsArrayToJsonString({ measureId, fileId, isCover })
    );
  },
  /**
   * 移除测量点照片
   */
  removePhotoForMeasure(id) {
    return axios.post(
      base.measure.removePhotoForMeasure,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 设置测量点相册封面
   */
  setMeasureAlbumCover(id) {
    return axios.post(
      base.measure.setMeasureAlbumCover,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 获取测量点相册封面
   */
  getMeasureAlbumCover(measureId) {
    return axios.post(
      base.measure.getMeasureAlbumCover,
      utils.postParamsArrayToJsonString({ measureId })
    );
  },
  /**
   * 查询
   */
  getMeasuresInfoByParam(companyId, param, value) {
    return axios.post(
      base.measure.getMeasuresInfoByParam,
      utils.postParamsArrayToJsonString({ companyId, param, value })
    );
  },
  /**
   * 查询
   */
  getMeasuresInfoByParam2(companyId, params) {
    return axios.post(
      base.measure.getMeasuresInfoByParam2,
      utils.postParamsArrayToJsonString({ companyId, params })
    );
  },
  /**
   * 查询可视计量点
   */
  getViewableMeasures(companyId) {
    return axios.post(
      base.measure.getViewableMeasures,
      utils.postParamsArrayToJsonString({ companyId })
    );
  },
  /**
   * 分享测量点
   */
  shareMeasuresWithCompany(srcCompanyId, dstCompanyId, measuresId) {
    return axios.post(
      base.measure.shareMeasuresWithCompany,
      utils.postParamsArrayToJsonString({
        srcCompanyId,
        dstCompanyId,
        measuresId,
      })
    );
  },
  /**
   * 取消分享测量点
   */
  unshareMeasuresWithCompany(srcCompanyId, dstCompanyId, measuresId) {
    return axios.post(
      base.measure.unshareMeasuresWithCompany,
      utils.postParamsArrayToJsonString({
        srcCompanyId,
        dstCompanyId,
        measuresId,
      })
    );
  },
  /**
   * 查询"我"分享测量点
   */
  listMeasuresOfMyCompanyShared(companyId) {
    return axios.post(
      base.measure.listMeasuresOfMyCompanyShared,
      utils.postParamsArrayToJsonString({ companyId })
    );
  },
  /**
   * 查询分享给"我"的测量点
   */
  listMeasuresOfOtherCompanySharedWithMe(companyId, otherCompanies) {
    return axios.post(
      base.measure.listMeasuresOfOtherCompanySharedWithMe,
      utils.postParamsArrayToJsonString({ companyId, otherCompanies })
    );
  },

  /**
   * 查询去重复计量点公式
   * @param {*} ids  [id1, id2, ..]
   */
  getUniqueMeasuresExpressions(ids) {
    let _self = this;
    return new Promise(function (resolve, reject) {
      _self.getMeasuresExpressions(ids).then((res) => {
        if (res && res.data) {
          let data = res.data;
          for (let i = 0; i < data.length; i++) {
            const item = data[i];
            for (let j = 0; j < item.expressionGroups.length; j++) {
              const group = item.expressionGroups[j];
              let names = [];
              const expression = group.expression;
              let newExpressionData = [];
              for (let k = 0; k < expression.length; k++) {
                const expressionItem = JSON.parse(
                  JSON.stringify(expression[k])
                );
                const index = names.indexOf(expressionItem.name);
                if (index === -1) {
                  names.push(expressionItem.name);
                  let itemData = [JSON.parse(JSON.stringify(expressionItem))];
                  expressionItem.data = itemData;
                  newExpressionData.push(expressionItem);
                } else {
                  newExpressionData[index].data.push(expressionItem);
                }
              }
              group.expression = newExpressionData;
            }
          }
          res.data = data;
        }
        // return res
        resolve(res);
      });
    });
  },
  /**
   * 查询测量点参数
   * @param {*} measureId 测量点id
   */
  getMeasuresParams(measuresId) {
    let params = {
      measuresId: JSON.stringify(measuresId),
    };
    return axios.post(
      base.measure.getMeasuresParams,
      utils.postParamsArrayToJsonString(params)
    );
  },
  /**
  * 从容器内查询测量点
  * @param {*} measureId 测量点id
  * @param {*} container ''。
  * @param {*} typeClass:TypeOfElectricityConsumption
  当此参数为空/null时，返回该测量点所有容器内容
  */
  getBottomNodeEnumClass(measureId, typeClass, container) {
    let params = {
      measureId,
      typeClass,
      container,
    };
    return axios.post(base.measure.getEnergyViewRelationshipSetting);
  },

  // 获取设备
  getViewTreesInfoByCompanyId(companyId) {
    return axios.post(
      base.measure.getViewTreesInfoByCompanyId,
      utils.postParamsArrayToJsonString({ companyId })
    );
  },
  getMeasureInfoByViewTreeId(viewTreeId) {
    return axios.post(
      base.measure.getMeasureInfoByViewTreeId,
      utils.postParamsArrayToJsonString({ viewTreeId })
    );
  },
  getMultiMeasurePointedProperty(params) {
    return axios.post(
      "/api/getMultiMeasurePointedProperty",
      utils.postParamsArrayToJsonString(params)
    );
  },
  getDirectSubNode(measureId, viewName) {
    return axios.post(
      "/api/getDirectSubNode",
      utils.postParamsArrayToJsonString({ measureId, viewName })
    );
  },
};

export default measure;
